import styled, { keyframes } from 'styled-components';

const muiShimmer = keyframes`
  0% {
    background-position: -150px 0;
  }
  100% {
    background-position: 150px 0;
  }
`;

export const SkeletonText = styled.span<{
  width?: number;
  height?: number;
}>`
  display: inline-block;
  height: ${({ height }) => (height ? `${height}px` : '20px')};
  width: ${({ width }) => (width ? `${width}px` : '350px')};
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.11); /* gris base MUI */
  background-image: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.11) 0px,
    rgba(0, 0, 0, 0.07) 40px,
    rgba(0, 0, 0, 0.11) 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${muiShimmer} 1.6s ease-in-out infinite;
  vertical-align: middle;
`;
